// $(document).ready(function(){
//   $("#age-screen").addClass("pop-up");
//   $("#yes-btn").click(function(){
//     $("#age-screen").removeClass("pop-up");
//   });
//    $("#no-btn").click(function(){
  
// window.close();
//    });
// });

$(document).ready(function(){


$("#yes-btn").click(function(){
localStorage.setItem('isAllowed', 'yes');
   $(".age-screen").css("display","none");
});

let isAllowed = localStorage.getItem('isAllowed');

if (isAllowed === 'yes') {
   $(".age-screen").css("display","none");
}
  else{
  
    $(".age-screen").css("display","flex");
}
     $("#no-btn").click(function(){
 var win = window.open("about:blank","_self");
        win.close();
   });
});
